import { Component, OnInit,ChangeDetectorRef  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist }  from '../class/status';
import { chartdata }  from '../class/chatdata';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
@Component({
  selector: 'app-customervalue',
  templateUrl: './customervalue.component.html',
  styleUrls: ['./customervalue.component.css']
})
export class CustomervalueComponent implements OnInit {
  constructor(
    public httpClient: HttpClient,
    private cdr: ChangeDetectorRef
){}
  Highcharts: typeof Highcharts = Highcharts;
  updateFlag:boolean=false;
  isActive :boolean=false;
  loading:boolean=true;
  now:string='0';
  tool_obj:any={search_model:'',action:'0'};
  menu_list:menulist = [
    {id:'0',name:'顧客價值'},
    {id:'1',name:'顧客留存率'},
    {id:'2',name:'儲值數據'},
  ]
  areaOptions:  Highcharts.Options = JSON.parse(JSON.stringify(chartdata.area_bar));

  ngOnInit(): void {
    this.init_list();
  }

  init_chart(data) {
    
    const rename_list = [
      { id: '0', title: '顧客價值', des: '顧客價值 (客單價=總金額/客戶數)' },
      { id: '1', title: '留存率', des: '顧客壽命 (有消費的月份)' },
      { id: '2', title: '儲值數據', des: '' },
    ];
  
    const obj = rename_list.find(item => item.id === this.now);
    const title = obj.title;
    const des = obj.des;
    
    this.areaOptions = chartdata.assign_num_data(JSON.parse(JSON.stringify(this.areaOptions)),{
      type: 'area',
      name: 'Series 1',
      data: [10, 20, 30, 40],
    },data['result'].length)
  

    this.areaOptions.xAxis = {
      categories: data.date
    }

    this.areaOptions.title = {
      text: title
    }
    
    let series = [];
    for(let i in data['result']){
      let tmp_obj = data['result'][i];

      tmp_obj.marker = {
        enabled: false
      }
      tmp_obj.threshold = null
      tmp_obj.dataLabels = {
        enabled: true,  // 啟用數據標籤
        formatter: function () {
            return Highcharts.numberFormat(this.y, 2, '.', ','); // Custom formatting
        },
      }
      series.push(tmp_obj);
      // this.areaOptions.series.push(tmp_obj);
     
    }
    this.areaOptions.series = series;
    console.log('this.areaOptions',this.areaOptions);

    this.isActive  = true;
  }

  init_list(){
    this.loading = true;
    const body = {action:this.now};
    this.httpClient.post<any>("/v1/data_analyze/get_customer_value.php",body).subscribe(res => {
        this.loading = false;
        this.init_chart(res.data);
        this.updateFlag = true;
        console.log('res',res);
    });
  }

  choose(value:string){
    this.isActive  = false;
    this.now = value;
    this.init_list();
  }

}
